"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlignment = getAlignment;

var _styledComponents = require("styled-components");

var _index = require("./index");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: ", ";\n    justify-content: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function getAlignmentValue(direction, alignment) {
  return "".concat((0, _index.parseAlignment)(alignment === null || alignment === void 0 ? void 0 : alignment[(0, _index.getAlignmentFromDirection)(direction)]) || 'initial');
}

function getAlignment(_ref) {
  var direction = _ref.direction,
      alignment = _ref.alignment;
  return (0, _styledComponents.css)(_templateObject(), getAlignmentValue((0, _index.reverseDirection)(direction), alignment), getAlignmentValue(direction, alignment));
}